import React from 'react';
import { useQueries } from 'react-query';
import { INearbyResort, IRegionShort } from 'api/region/types';
import { IResortPathInfo } from 'api/resort/types';
import { fetchResortShortInfo } from 'api/resort/static';
import { fetchRegionFeatured } from 'api/region/static';
import { NearbyResortsSection } from '../NearbyResortsSection';
import styles from './styles.module.scss';

export const RelatedRegionResortList = ({
  resorts,
  regions,
}: {
  title?: string,
  resorts: IResortPathInfo[],
  regions: IRegionShort[],
  isFresh: boolean,
}) => {
  // Manually filter out United States (hack)
  const filteredRegions = regions.filter((e) => e.uuid !== '429');

  const sortedResorts = resorts?.slice(0, 3);
  const sortedRegions = filteredRegions?.slice(0, (3 - sortedResorts?.length));

  // Fetch resort images
  const resortQueries = useQueries(
    sortedResorts.map((resort) => ({
      queryKey: ['resort-fetchResortShortInfo', resort.uuid],
      queryFn: () => fetchResortShortInfo(resort.uuid),
    })),
  );

  // Fetch region images
  const regionQueries = useQueries(
    sortedRegions.map((region) => ({
      queryKey: ['region-fetchRegionFeatured', region.uuid],
      queryFn: () => fetchRegionFeatured(region.uuid),
    })),
  );

  const nearbyResorts = [
    ...sortedResorts.map((item, index) => {
      const resortData = resortQueries[index]?.data;
      return {
        uuid: item.uuid,
        slug: item.slug,
        domain: item.domain,
        title: item.title,
        region: { slug: item.region },
        image: resortData?.image || '',
        imageCaption: resortData?.title || '',
      };
    }),
    ...sortedRegions.map((item, index) => {
      const regionData = regionQueries[index]?.data;
      return {
        uuid: item.uuid,
        slug: item.slug,
        title: item.title,
        region: item,
        image: regionData?.details?.image || '',
        imageCaption: regionData?.details?.title || '',
      };
    }),
  ] as INearbyResort[];

  return (
    <div className={styles.paddingWrapper}>
      <NearbyResortsSection nearbyResorts={nearbyResorts} />
    </div>
  );
};
